import { defineSlotRecipe } from '@chakra-ui/react';
import { dialogAnatomy } from '@chakra-ui/react/anatomy';

export const dialogSlotRecipe = defineSlotRecipe({
  slots: dialogAnatomy.keys()
  //need variants in base
  // base: {
  //   header: {
  //     borderBottom: 'solid 1px',
  //     borderColor: 'gray.400',
  //     m: '4px'
  //   },
  //   body: {
  //     p: '4px',
  //     m: '0px'
  //   }
  // }
});
